














































import { Component, Ref } from 'vue-property-decorator';
import Vue from 'vue';
import { IssueEntity } from '@/entities/issue.entity';
import IssueService from '@/services/issue.service';
import { UseService } from '@/services/service';
import IssueDetailHeaderPc from '@/components/ViewComponent/Issue/IssueDetail/IssueDetailHeaderPc.vue';
import IssueDetailDescriptionPc from '@/components/ViewComponent/Issue/IssueDetail/IssueDetailDescriptionPc.vue';
import IssueCommentBoxPc from '@/components/ViewComponent/Issue/IssueDetail/IssueCommentBoxPc.vue';
import IssueCommentsPc from '@/components/ViewComponent/Issue/IssueDetail/IssueCommentsPc.vue';
import BorderCard from '@/components/Helper/Card/BorderCard.vue';
import IssueDetailHeaderSp from '@/components/ViewComponent/Issue/IssueDetail/IssueDetailHeaderSp.vue';
import { StaffEntity } from '@/entities/staff.entity';
import { mapActions, mapGetters } from 'vuex';
import IssueDetailFooterPc from '@/components/ViewComponent/Issue/IssueDetail/IssueDetailFooterPc.vue';

const COMMENT_BOX_BOTTOM = 12;

@Component<IssueDetail>({
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
  },
  components: {
    IssueDetailFooterPc,
    IssueDetailHeaderSp,
    BorderCard,
    IssueCommentsPc,
    IssueCommentBoxPc,
    IssueDetailDescriptionPc,
    IssueDetailHeaderPc,
  },
})
export default class IssueDetail extends Vue {
  currentStaff!: StaffEntity;
  fetchCurrentStaff!: () => void;

  issue: IssueEntity = null;

  commentBoxHeight = 0;

  loading = true;

  @UseService(IssueService)
  service: IssueService;

  @Ref('issue-description')
  issueDescription!: Vue;

  @Ref('comment-box')
  commentBox!: Vue;

  get id(): number {
    return this.$route.params.id as unknown as number;
  }
  async updated() {
    // console.log(this.$refs.container__issue);
  }
  async mounted(): Promise<void> {
    this.$cheeers.socket.on('issue@updated', async () => {
      this.issue = await this.service.getOne(this.id);
      await this.calculateHeight();
    });
    this.issue = await this.service.getOne(this.id);
    this.loading = false;
    await this.calculateHeight();
    const { id } = this.$route.params;
    if (id) {
      await this.$http.patch('/notify-issue/isread-notify-issue', {
        issueId: Number(id),
      });
    }
  }

  async calculateHeight(): Promise<void> {
    await this.$nextTick();
    if (this?.commentBox?.$el?.clientHeight) {
      this.commentBoxHeight =
        this.commentBox.$el.clientHeight + COMMENT_BOX_BOTTOM;
    } else {
      this.commentBoxHeight = 0;
    }
  }

  get style(): Partial<CSSStyleDeclaration> {
    return {
      height: `calc(100% - ${this.commentBoxHeight}px)`,
    };
  }

  get isShowFooter(): boolean {
    return (
      this.issue.staffId === this.currentStaff.id &&
      this.issue.supporters &&
      this.issue.supporters.length > 0
    );
  }
}
